module.exports = __webpack_public_path__ + "static/img/xw.7fd217c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xw.png
// module id = 0SZN
// module chunks = 1